<template>
  <div class="wap_index7">
    <div class="wap_index7_box">
      <div class="wap_index7_titel">合作条款</div>
      <div class="wap_index7_cut">
        <div
          v-for="(item, index) in wap7Navlist"
          :key="index"
          @click="wap7Navpitc(index)"
        >
          <div>
            <div
              :class="item.show ? `clause${index}1` : `clause${index}`"
            ></div>
          </div>
          <div
            class="wap_index7_cutSize"
            :class="item.show ? '' : 'wap_index7_cutSize_activate'"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="wap_index7_cut_info">
        <div class="wap_index7_cut_swiper">
          <div style="width: 97%">
            <div
              v-for="(item, index) in wap7Navlist[wap7NavIndex].info"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="viewportHeight" class=""></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wap7Navlist: [], //合作条款内容
      wap7NavIndex: 0, //合作条款当前展示内容
      viewportHeight: true,
      clauseList: [
        //合作案例内容
        {
          title: "合作优势",
          info: [
            "①合作产品可免费入驻《千年游戏盒子》，基于产品品质上线首周获得推荐资源位扶持",
            "②我们拥有众多高完成度游戏版本供开发者选择",
            "③强大的游戏开发引擎和技术服务人员支持个性化内容定制",
            "④专业的技术，运营，市场，客服团队7*24小时全程保驾护航",
            "⑤完善的运营及运维工具让产品成功之路事半功倍",
            "⑥我们拥有《千年》网络游戏中国大陆地区独家代理权,打击权",
            "⑦我们相信只有共同努力，才能打造好千年游戏IP，让广大玩家有更优质的游戏体验",
          ],
          show: false,
        },
        {
          title: "成本支出",
          info: ["您可联系授权商务咨询详情"],
          show: true,
        },
        {
          title: "分成收益",
          info: ["您可联系授权商务咨询详情"],
          show: true,
        },
        {
          title: "交付清单",
          info: [
            "①包含登录+支付系统的（IOS+安卓+pc ）三端互通最终游戏版本",
            "②万能渠道后台：集实时查看游戏数据，推广链接分发等功能",
            "③综合后台：集运营数据查看分析，游戏相关特殊信息一键透析",
            "④您专属的7*24小时技术，运营，客服团队全程服务",
          ],
          show: true,
        },
        {
          title: "正式上线",
          info: [
            "①正式上线后我们将持续辅助您做好正式上线后的游戏运营，推广，后续版本迭代服务",
          ],
          show: true,
        },
      ],
    };
  },
  created() {
    this.wap7Navlist = JSON.parse(JSON.stringify(this.clauseList));
  },
  mounted() {},
  methods: {
    // 合作条款选中
    wap7Navpitc(index) {
      this.wap7Navlist.forEach((item) => {
        item.show = true;
      });
      this.wap7Navlist[index].show = false;
      this.wap7NavIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
.wap_index7 {
  width: 100%;
  height: 100%;
  background: #1d1d1d;
  position: relative;
}
.wap_index7_box {
  width: 9.333333rem /* 350/37.5 */;
  margin: 0 auto;
  width: 90%;
}
.wap_index7_titel {
  text-align: center;
  padding-top: 1.466667rem /* 55/37.5 */;
  padding-bottom: 0.533333rem /* 20/37.5 */;
  font-size: 0.533333rem /* 20/37.5 */;
  font-weight: bold;
  color: #fff;
}
.wap_index7_cut {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wap_index7_cutSize {
  font-size: 0.32rem /* 12/37.5 */;
  font-weight: bold;
  color: #707070;
  padding-top: 0.213333rem /* 8/37.5 */;
  text-align: center;
}
.wap_index7_cutSize_activate {
  color: #fff;
}
.wap_index7_cut > div > div:nth-child(1) {
  width: 0.906667rem /* 34/37.5 */;
  height: 0.773333rem /* 29/37.5 */;
  width: 1.066667rem /* 40/37.5 */;
  height: 0.533333rem /* 20/37.5 */;
  background-size: cover;
  margin: 0 auto;
}
.wap_index7_cut > div > div:nth-child(1) > div {
  width: 0.88rem /* 33/37.5 */;
  height: 0.746667rem /* 28/37.5 */;
  background-size: cover;
  margin: 0 auto;
}

.wap_index7_cut_info {
  margin-top: 0.533333rem /* 20/37.5 */;
  /* height: 8rem ; */
  background: #161616;
  border-radius: 0.4rem /* 15/37.5 */;
  border: 1px solid #707070;
  box-sizing: border-box;
  padding: 0.48rem /* 18/37.5 */ 0;
  padding-left: 0.346667rem /* 13/37.5 */;
  padding-right: 0.266667rem /* 10/37.5 */;
  font-size: 0.373333rem /* 14/37.5 */;
  color: #b1b1b1;
  line-height: 0.64rem /* 24/37.5 */;
  transform-origin: center top;
}

.wap_index7_cut_info > div::-webkit-scrollbar {
  width: 0.106667rem /* 4/37.5 */;
}

.wap_index7_cut_info > div::-webkit-scrollbar-thumb {
  background: #fff;
  /* 滑块颜色 */
  border-radius: 0.053333rem /* 2/37.5 */;
  /* 滑块圆角 */
}
.wap_index7_cut_info > div::-webkit-scrollbar-track {
  /* 轨道圆角 */
  background-color: #572f2a;
  /* 轨道颜色  */
}

.wap_index7_cut_bg {
  margin-top: 0.48rem /* 18/37.5 */;
  width: 100%;
  height: 7.333333rem /* 275/37.5 */;
  opacity: 0.37;
  background: url("../../assets/images/pc/flow_box1.gif") no-repeat center;
  background-size: cover;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.clause0 {
  background: url("../../assets/images/pc/clause1.png") no-repeat center;
}

.clause1 {
  width: 0.96rem /* 36/37.5 */ !important;
  height: 0.773333rem /* 29/37.5 */ !important;
  background: url("../../assets/images/pc/clause2.png") no-repeat center;
}

.clause2 {
  background: url("../../assets/images/pc/clause4.png") no-repeat center;
}

.clause3 {
  background: url("../../assets/images/pc/clause3.png") no-repeat center;
}

.clause4 {
  background: url("../../assets/images/pc/clause5.png") no-repeat center;
}
.clause01 {
  background: url("../../assets/images/web/clause_1.png") no-repeat center;
}

.clause11 {
  width: 0.96rem /* 36/37.5 */ !important;
  height: 0.773333rem /* 29/37.5 */ !important;
  background: url("../../assets/images/web/clause_2.png") no-repeat center;
}

.clause21 {
  background: url("../../assets/images/web/clause_3.png") no-repeat center;
}

.clause31 {
  background: url("../../assets/images/web/clause_4.png") no-repeat center;
}

.clause41 {
  background: url("../../assets/images/web/clause_5.png") no-repeat center;
}
@media (max-width: 750px) and (max-height: 667px) {
  .wap_index7_cut_bg {
    display: none;
  }
  .wap_index7_titel {
    padding-top: 1.466667rem /* 55/37.5 */;
    padding-bottom: 0.4rem /* 15/37.5 */;
  }
}

@media (max-width: 750px) and (max-height: 600px) {
  .wap_index7_cut_info{
    font-size: .32rem /* 12/37.5 */;
    line-height: .533333rem /* 20/37.5 */;
}
}
</style>
